import { gql, TypedDocumentNode } from '@apollo/client';
import { backendResponse } from '../../../common_lib_front/types/backendResponse';

// type EDIT_VEHICLE_VARS = {
//   vehicleId?: string;
//   newVehicleInfo: {
//     make?: string;
//     type?: string;
//     color?: string;
//     licensePlate?: string;
//     year?: number;
//     isPassEditPage?: boolean;
//     primaryDriverName?: string;
//   };
//   passInfoId: string;
// };

// export type EDIT_VEHICLE_RES = {
//   editVehicle: backendResponse<undefined>;
// };
// export const EDIT_VEHICLE: TypedDocumentNode<EDIT_VEHICLE_RES, EDIT_VEHICLE_VARS> = gql`
//   mutation EditVehicle(
//     $vehicleId: String!
//     $passInfoId: String!
//     $newVehicleInfo: ActuallyInputTypeVehicleInput!
//   ) {
//     editVehicle(
//       vehicleId: $vehicleId
//       newVehicleInfo: $newVehicleInfo
//       passInfoId: $passInfoId
//     ) {
//       success
//       error
//     }
//   }
// `;

type EDIT_PASS_VAR = {
  newInfo: {
    startDate: string;
    endDate: string;
    passInfoId: string;
  };
  passId: string;
};
export type EDIT_PASS_RES = {
  editPass: backendResponse<undefined>;
};
export const EDIT_PASS: TypedDocumentNode<EDIT_PASS_RES, EDIT_PASS_VAR> = gql`
  mutation editPass($passId: String!, $newInfo: PassInput!) {
    editPass(passId: $passId, newInfo: $newInfo) {
      success
      error
    }
  }
`;
